export const getDynamicTopGamesUrl = (host: string): string => `${host}/api/history/statistics/top-games`;
export const getGamesCurrentPlayersUrl = (host: string): string =>
    `${host}/api/history/statistics/current-players-count`;
export const getTranslationsUrl = (host: string, languageCode: string): string =>
    `${host}/assets/portal/translations/${languageCode.toLowerCase()}.json`;
//TODO: Extract this into a helper function to add demo suffix
export const getSettingsUrl = (host: string, isDemo: boolean = false): string =>
    `${host}/api/portal/settings${isDemo ? '?isDemo=true' : ''}`;
export const getJackpotStatsUrl = (host: string, isDemo: boolean = false): string => `${host}/api/jackpot/stats/internal${isDemo ? '/demo' : ''}`;
export const getJackpotWinStatsUrl = (host: string, instanceName: string): string =>
    `${host}/api/jackpot/win/stats?instanceName=${encodeURIComponent(instanceName)}`;
